/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const OrderItemPrice = require('./order_item_price').default;
const OrderItemPayment = require('./order_item_payment').default;
const OrderItemMappingList = require('./order_item_mapping_list').default;
const TransportElement = require('./transport_element');
const HotelElement = require('./hotel_element');
const CancelChargeElement = require('./cancel_charge_element');
const ShippingElement = require('./shipping_element').default;
const SupportFeeElement = require('./support_fee_element').default;
const WifiElement = require('./wifi_element').default;
const KitElement = require('./kit_element').default;
const RoomElement = require('./room_element').default;
const Traveler = require('./traveler/traveler');
const { Fetcher } = require('../util');
const TravelAuthorizationElement = require('./travel_authorization_element').default;
const InsuranceElement = require('./insurance_element').default;
const ChangeFeeElement = require('./change_fee_element').default;
const Journal = require('./journal').default;
const MarginType = require('./organization/margin_type2').default;
const TripStatus = require('./trip/trip_status').default;
const { OrderItemStatus } = require('./order_item/order_item_status');
const OrderItemSnoozedTodo = require('./order_item_snoozed_todo').default;
const ETicket = require('./e_ticket/e_ticket').default;
const OrderItemTodoMessageLog = require('./order_item_todo_message_log').default;
const { diff } = require('deep-object-diff');
const OrderItemStatusLog = require('./arrangement/order_item_status_log').default;
const OrderItemCalendarEvent = require('./order_item_calendar_event').default;
const TravelerShinkansenType = require('./traveler/traveler_shinkansen_type').default;
const { convertOrderItemCalendarEventResponseToArgs } = require('./order_item_calendar_event');

class OrderItem {
  constructor(args) {
    let transport;
    if (args == null) {
      args = {};
    }
    if (args.marginType) {
      this.marginType = new MarginType(args.margin_type);
    }

    // Serializer の値をそのまま使った方がコードがシンプルになるのでここで実行する
    const orderItemSnoozedTodos = args.order_item_snoozed_todos
      ? _.map(
          args.order_item_snoozed_todos,
          raw =>
            new OrderItemSnoozedTodo({
              id: raw.id,
              orderItemId: raw.order_item_id,
              arrangerId: raw.arranger_id,
              snoozeTo: raw.snooze_to,
              memo: raw.memo,
              canceled: raw.canceled
            })
        )
      : [];

    const orderItemTodoMessageLog = args.message_log
      ? new OrderItemTodoMessageLog({
          id: args.message_log.id,
          traceId: args.message_log.trace_id,
          arrangerId: args.message_log.arranger_id,
          arrangerName: args.message_log.arranger_name,
          createdAt: args.message_log.created_at,
          body: args.message_log.body
        })
      : null;

    const orderItemMappings = args.order_item_mappings
      ? new OrderItemMappingList(args.order_item_mappings)
      : new OrderItemMappingList([]);

    args = snakeToCamelObject(args);
    _.assign(this, args);
    this.peopleNum = args.peopleNum || 1;
    this.payment = new OrderItemPayment(args.payment || {});
    this.transports = _.map(args.transports, raw => {
      const peopleNum = raw.peopleNum || this.peopleNum;
      return new TransportElement(
        _.merge(raw, {
          peopleNum,
          carTypeOptions: this.carTypeOptions,
          carProviderOptions: this.carProviderOptions,
          serviceId: this.serviceId
        })
      );
    });
    this.hotels = _.map(args.hotels, raw => {
      const peopleNum = raw.peopleNum || this.peopleNum;
      return new HotelElement(_.merge(raw, { peopleNum }));
    });
    this.cancelCharges = _.map(args.cancelCharges || args.cancel_charges, raw => new CancelChargeElement(raw));
    this.changeFees = _.map(args.changeFees, raw => new ChangeFeeElement(raw));
    this.supportFees = _.map(args.supportFees, raw => new SupportFeeElement(raw));
    this.shippings = _.map(args.shippings, raw => {
      return new ShippingElement(_.merge(raw, { shippingCategoryOptions: this.shippingCategoryOptions }));
    });
    this.wifis = _.map(args.wifis, raw => {
      return new WifiElement(_.merge(raw, { wifiProviderOptions: this.wifiProviderOptions }));
    });
    this.rooms = _.map(args.rooms, raw => new RoomElement(raw));
    this.kits = _.map(args.kits, raw => new KitElement(raw));
    this.travelAuthorizations = _.map(args.travelAuthorizations, raw => new TravelAuthorizationElement(raw));
    this.insurances = _.map(args.insurances, raw => new InsuranceElement(raw));
    this.elements = this.transports
      .concat(this.hotels)
      .concat(this.cancelCharges)
      .concat(this.changeFees)
      .concat(this.supportFees)
      .concat(this.shippings)
      .concat(this.wifis)
      .concat(this.rooms)
      .concat(this.kits)
      .concat(this.travelAuthorizations)
      .concat(this.insurances);
    const marginType = this.currentMarginType();
    this.price = new OrderItemPrice(
      _.merge(args.price, { showFee: this.showFee, marginType, peopleNum: this.peopleNum })
    );
    this.firstPrice = new OrderItemPrice(
      _.merge(args.firstPrice, { showFee: this.showFee, marginType, peopleNum: this.peopleNum })
    );
    this.type = args.orderItemType;
    this.additionalType = 'hotel';
    this.travelerInformations = args.travelerInformations ? Object.values(args.travelerInformations) : [];
    for (var traveler of Array.from(this.travelerInformations)) {
      traveler.travelerInformationShinkansenTypes = traveler.travelerInformationShinkansenTypes
        ? Object.values(traveler.travelerInformationShinkansenTypes)
            .map(s => new TravelerShinkansenType(s))
            .sort((a, b) => a.idx - b.idx)
        : [];
    }
    this.travelers = _.map(this.travelerInformations, raw => new Traveler(raw));
    this.hotelPriceLimit = args.hotelPriceLimit;
    if (args.billedAt) {
      this.billedAt = moment(args.billedAt);
    }
    this.status = args.status;
    this.jobTypeValue = args.jobType;

    this.initialData = _.cloneDeep(this);
    this.isEditing = args.isEditing || false;

    this.orderItemMappings = orderItemMappings;

    this.eTickets = _.map(args.eTickets, raw => new ETicket(raw));
    this.prevItem = args.prevItem ? new OrderItem(args.prevItem) : null;
    this.firstItem = args.firstItem ? new OrderItem(args.firstItem) : null;

    // 旅程履歴用
    // j.tagsが連想配列になってるので通常の配列に変換
    this.journals = args.journals
      ? _.map(args.journals, function (j) {
          j.tags = _.values(j.tags);
          return new Journal(j);
        })
      : [];
    this.tmpGmoSalesJournals = args.tmpGmoSalesJournals
      ? _.map(args.tmpGmoSalesJournals, function (j) {
          j.tags = _.values(j.tags);
          return new Journal(j);
        })
      : [];
    this.tmpGmoCancelJournals = args.tmpGmoCancelJournals
      ? _.map(args.tmpGmoCancelJournals, function (j) {
          j.tags = _.values(j.tags);
          return new Journal(j);
        })
      : [];

    // for /arrangement/todo_list
    this.status = args.status;
    this.statusStr = this.status ? OrderItemStatus[this.status] : '';
    this.arrangerName = args.arranger && args.arranger.name ? args.arranger.name : '';
    this.orderItemSnoozedTodos = orderItemSnoozedTodos;
    this.orderItemTodoMessageLog = orderItemTodoMessageLog;
    this.supplierSuppliedItemNames = [];
    for (var originalPrice of Array.from(this.price.originalPrices)) {
      if (originalPrice.suppliedItem && originalPrice.suppliedItem.supplier) {
        this.supplierSuppliedItemNames.push(
          originalPrice.suppliedItem.supplier.name + '：' + originalPrice.suppliedItem.name
        );
      }
    }
    this.deliveryAndBookingConfirmation = ['hotel', 'domestic_hotel', 'foreign_hotel'].includes(
      this.orderItemCategory
    )
      ? 'ホテル（予約番号）：' + [Array.from(this.hotels).map(hotel => hotel.hotelReservationNumber)].join(', ')
      : this.orderItemCategory === 'domestic_air'
      ? '国内航空券（確認番号）：' +
        [
          (() => {
            const result = [];
            for (transport of Array.from(this.transports)) {
              result.push(transport.airConfirmationNumber);
            }
            return result;
          })()
        ].join(', ')
      : this.orderItemCategory === 'foreign_air'
      ? '海外航空券（PNR）：' + this.pnr_id
      : this.orderItemCategory === 'shinkansen'
      ? '新幹線（配達記録番号）：' +
        [
          (() => {
            const result1 = [];
            for (transport of Array.from(this.transports)) {
              result1.push(transport.postingNumber);
            }
            return result1;
          })()
        ].join(', ')
      : this.orderItemCategory === 'express'
      ? '特急（配達記録番号）：' +
        [
          (() => {
            const result2 = [];
            for (transport of Array.from(this.transports)) {
              result2.push(transport.postingNumber);
            }
            return result2;
          })()
        ].join(', ')
      : '';
    this.deliveryCheckedByName =
      args.deliveryCheckedBy && args.deliveryCheckedBy.name ? args.deliveryCheckedBy.name : '';
    if (args.deliveryCheckedAt) {
      this.deliveryCheckedAt = moment(args.deliveryCheckedAt);
    }
    if (args.ticketedAt) {
      this.ticketedAt = moment(args.ticketedAt);
    }
    if (args.deliveredAt) {
      this.deliveredAt = moment(args.deliveredAt);
    }
    if (args.approvedAt) {
      this.approvedAt = moment(args.approvedAt);
    }
    if (args.updatedAt) {
      this.updatedAt = moment(args.updatedAt);
    }
    this.orderItemStatusLogs = _.map(args.orderItemStatusLogs, log => new OrderItemStatusLog(log));
    this.foreignFlightTicketIssuer = args.foreignFlightTicketIssuer;
    this.tsdInvoiceNumber = args.tsdInvoiceNumber;
    this.jrAuthCode = args.jrAuthCode;
    this.jrPickupCode = args.jrPickupCode;
    if (args.purchaseDeadline) {
      this.purchaseDeadline = moment(args.purchaseDeadline);
    }
    this.orderItemCalendarEvents = args.orderItemCalendarEvents
      ? _.map(args.orderItemCalendarEvents, event => new OrderItemCalendarEvent(event))
      : [];
    this.isWorking = args.isWorking;
    this.workingArrangerId = args.workingArrangerId;
    this.workStartedAt = args.workStartedAt;
    this.workEndedAt = args.workEndedAt;
  }

  startDate() {
    const dates = _.compact(_.map(this.elements, element => element.startDate()));
    return _.first(_.sortBy(dates, d => d.toDate()));
  }

  startDateStr() {
    const d = this.startDate();
    if (d) {
      return d.format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  // /trips/:id/edit での日時順並び替えのため
  startDateTime() {
    const date = _.first(
      _.sortBy(
        _.compact(
          _.map(this.elements, function (element) {
            if (element instanceof HotelElement) {
              return moment(element.startDate().format('YYYY-MM-DD') + ' 23:59:59');
            } else {
              return element.startDate();
            }
          })
        )
      )
    );
    return date;
  }

  endDate() {
    const dates = _.compact(_.map(this.elements, element => element.endDate()));
    return _.last(_.sortBy(dates, d => d.toDate()));
  }

  endDateStr() {
    const d = this.endDate();
    if (d) {
      return d.format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  typeStr() {
    switch (this.type) {
      case 0:
        return '往路';
      case 1:
        return '復路';
      case 2:
        return 'ホテル';
      case 3:
        return '航空券';
      case 4:
      case 9:
      case 10:
      case 11:
      case 12:
        return 'パッケージ';
      case 5:
        return '経路';
      case 20:
        return '出張サポート費';
      case 6:
        return '配送料';
      case 7:
        return 'WiFi';
      case 8:
        return '会議室';
      case 21:
        return '検査キット';
      case 22:
        return '変更手数料';
      case 23:
        return '査証・渡航認証関連';
      case 24:
        return '保険';
    }
  }

  categoryStr() {
    switch (this.orderItemCategory) {
      case 'hotel':
        return 'ホテル';
      case 'domestic_air':
        return '航空券';
      case 'foreign_air':
        return '航空券';
      case 'shinkansen':
        return '新幹線';
      case 'express':
        return '特急';
      case 'railway_ticket':
        return '在来線';
      case 'rental_car':
        return 'レンタカー';
      case 'wbf_package':
        return 'パッケージ';
      case 'cancel':
        return 'キャンセル料';
      case 'other':
        return 'その他';
      case 'support_fee':
        return '出張サポート費';
      case 'change_fee':
        return '変更手数料';
      case 'shipping':
        return '配送料';
      case 'wifi':
        return 'WiFi';
      case 'room':
        return '会議室';
      case 'kit':
        return '検査キット';
      case 'bus':
        return 'バス';
      case 'ana_tabisaku':
        return 'ANA旅作';
      case 'arrangement_request':
        return 'リクエストフォーム利用料';
      case 'travel_authorization':
        return '査証・渡航認証関連';
      case 'insurance':
        return '保険';
    }
  }

  elementType() {
    switch (this.typeStr()) {
      case 'ホテル':
        return 'hotel';
      case '往路':
      case '復路':
      case '経路':
      case '航空券':
        return 'transport';
      default:
        return undefined;
    }
  }

  isPackage() {
    switch (this.type) {
      case 4:
      case 9:
      case 10:
      case 11:
      case 12:
        return true;
      default:
        return false;
    }
  }

  mappingDescription() {
    const desc = __guard__(_.first(this.elements), x => x.mappingDescription());
    if (!!desc) {
      return desc;
    } else {
      return this.categoryStr();
    }
  }

  totalPriceWithAll() {
    return this.price.totalPriceWithAll();
  }

  isHotelOnly() {
    for (var element of Array.from(this.elements)) {
      if (element.type !== 'hotel') {
        return false;
      }
    }
    return true;
  }

  isDomesticAirOnly() {
    for (var element of Array.from(this.elements)) {
      if (element.type !== 'transport' || !element.isDomesticAir()) {
        return false;
      }
    }
    return true;
  }

  isForeignAirOnly() {
    for (var element of Array.from(this.elements)) {
      if (element.type !== 'transport' || !element.isForeignAir()) {
        return false;
      }
    }
    return true;
  }

  isShinkansenOnly() {
    for (var element of Array.from(this.elements)) {
      if (element.type !== 'transport' || (!element.isShinkansen() && !element.isExpress())) {
        return false;
      }
    }
    return true;
  }

  isOtherOnly() {
    return this.typeStr() === 'パッケージ';
  }

  isChangeableExist() {
    for (var element of Array.from(this.elements)) {
      if (element.type === 'transport' && element.isDomesticAir() && element.isChangeable()) {
        return true;
      }
    }
    return false;
  }

  isSnoozing() {
    let snoozing = false;
    if (this.orderItemSnoozedTodos) {
      _.each(this.orderItemSnoozedTodos, function (todo) {
        if (todo.isSnoozing()) {
          snoozing = true;
          return;
        }
      });
    }
    return snoozing;
  }

  currentSnooze() {
    let snooze = null;
    if (this.orderItemSnoozedTodos) {
      _.each(this.orderItemSnoozedTodos, function (todo) {
        if (todo.isSnoozing()) {
          snooze = todo;
          return;
        }
      });
    }
    return snooze;
  }

  isAvailableBulkTicket() {
    return this.isShinkansenOnly() && this.payment.isBulkTicket();
  }

  isExist() {
    return !_.isEmpty(this.elements);
  }

  isPriceChanged() {
    return this.firstItem && this.firstItem.price.totalPrice() !== this.price.totalPrice();
  }

  isTicketingExpired() {
    const expired_flights = _.filter(
      this.elements,
      e => e.type === 'transport' && e.isForeignAir() && e.isTicketingExpired()
    );
    return expired_flights.length > 0;
  }

  isFollowingElement(element) {
    if (element.type !== 'transport' || !element.isForeignAir()) {
      return false;
    }

    const firstForeignAir = _.filter(this.elements, e => e.type === 'transport' && e.isForeignAir())[0];
    return firstForeignAir && firstForeignAir.id !== element.id;
  }

  isPrecedingElement(element) {
    if (element.type !== 'transport' || !element.isForeignAir()) {
      return false;
    }

    const lastForeignAir = _.filter(this.elements, e => e.type === 'transport' && e.isForeignAir()).pop();
    return lastForeignAir && lastForeignAir.id !== element.id;
  }

  isCanceled() {
    return this.jobType === 'cancel' && _.includes([7, 13], this.status);
  }

  showTicketingDeadline(element) {
    if (!element.ticketingExpiredAt) {
      return false;
    }
    return !this.isPrecedingElement(element);
  }

  travelerShinkansenTypes(elementIndex = null) {
    if (this.orderItemCategory !== 'shinkansen' && this.orderItemCategory !== 'express') {
      return [];
    }

    // elementIndex毎にキャッシュを管理
    if (!this._travelerShinkansenTypesCache) {
      this._travelerShinkansenTypesCache = {};
    }
    const cacheKey = (elementIndex != null ? elementIndex.toString() : undefined) || 'null';
    if (this._travelerShinkansenTypesCache[cacheKey]) {
      return this._travelerShinkansenTypesCache[cacheKey];
    }

    this._travelerShinkansenTypesCache[cacheKey] = this.travelers.map(travelerInformation =>
      travelerInformation.getTravelerShinkansenType(elementIndex)
    );
    return this._travelerShinkansenTypesCache[cacheKey];
  }

  travelerShinkansenSeatTypes(elementIndex = null) {
    if (this.orderItemCategory !== 'shinkansen' && this.orderItemCategory !== 'express') {
      return [];
    }

    if (!this._travelerShinkansenSeatTypesCache) {
      this._travelerShinkansenSeatTypesCache = {};
    }
    const cacheKey = (elementIndex != null ? elementIndex.toString() : undefined) || 'null';
    if (this._travelerShinkansenSeatTypesCache[cacheKey]) {
      return this._travelerShinkansenSeatTypesCache[cacheKey];
    }

    this._travelerShinkansenSeatTypesCache[cacheKey] = this.travelers.map(travelerInformation =>
      travelerInformation.getShinkansenSeatTypeText(elementIndex)
    );
    return this._travelerShinkansenSeatTypesCache[cacheKey];
  }

  travelerShinkansenTicketTypes(elementIndex = null) {
    if (this.orderItemCategory !== 'shinkansen' && this.orderItemCategory !== 'express') {
      return [];
    }
    if (this._travelerShinkansenTicketTypes) {
      return this._travelerShinkansenTicketTypes;
    }

    if (!this._travelerShinkansenTicketTypesCache) {
      this._travelerShinkansenTicketTypesCache = {};
    }
    const cacheKey = (elementIndex != null ? elementIndex.toString() : undefined) || 'null';
    if (this._travelerShinkansenTicketTypesCache[cacheKey]) {
      return this._travelerShinkansenTicketTypesCache[cacheKey];
    }

    this._travelerShinkansenTicketTypesCache[cacheKey] = this.travelers.map(travelerInformation =>
      travelerInformation.getShinkansenTicketTypeText(elementIndex)
    );
    return this._travelerShinkansenTicketTypesCache[cacheKey];
  }

  travelerAirlineTypes() {
    if (this.orderItemCategory !== 'domestic_air' && this.orderItemCategory !== 'foreign_air') {
      return [];
    }
    if (this._travelerAirlineTypes) {
      return this._travelerAirlineTypes;
    }

    if (this.orderItemCategory === 'domestic_air') {
      this._travelerAirlineTypes = this.travelers.map(travelerInformation =>
        travelerInformation.getTravelerAirlineTypeDomestic()
      );
    }

    if (this.orderItemCategory === 'foreign_air') {
      this._travelerAirlineTypes = this.travelers.map(travelerInformation =>
        travelerInformation.getTravelerAirlineTypeForeign()
      );
    }

    return this._travelerAirlineTypes;
  }

  handleToggleEditing() {
    if (this.isEditing === true) {
      this._restore();
    }
    this.isEditing = !this.isEditing;
    return app.render();
  }

  handleChangeType(index, value) {
    this.elements[index] = (() => {
      switch (value) {
        case 'transport':
          return new TransportElement();
        case 'hotel':
          return new HotelElement();
        case 'cancel':
          return new CancelChargeElement({
            startAt: this.elements[index].startDate(),
            endAt: this.elements[index].endDate()
          });
        case 'change_fee':
          return new ChangeFeeElement({
            startAt: this.elements[index].startDate(),
            endAt: this.elements[index].endDate()
          });
        case 'support_fee':
          return new SupportFeeElement();
        case 'shipping':
          return new ShippingElement({ shippingCategoryOptions: this.shippingCategoryOptions });
        case 'wifi':
          return new WifiElement({ wifiProviderOptions: this.wifiProviderOptions });
        case 'room':
          return new RoomElement();
        case 'kit':
          return new KitElement();
        case 'travel_authorization':
          return new TravelAuthorizationElement({});
        case 'insurance':
          return new InsuranceElement({});
      }
    })();
    this.updatePriceShowFee();
    this.fetchCategory();
    return app.render();
  }

  handleSelectAdditionalType(type) {
    this.additionalType = type;
    return app.render();
  }

  handleAddElementByType(e) {
    e.preventDefault();
    const args = { peopleNum: this.peopleNum };
    const element = (() => {
      switch (this.additionalType) {
        case 'hotel':
          return new HotelElement(args);
        case 'transport':
          return new TransportElement(args);
        case 'cancel':
          return new CancelChargeElement(args);
        case 'change_fee':
          return new ChangeFeeElement(args);
        case 'support_fee':
          return new SupportFeeElement(args);
        case 'shipping':
          return new ShippingElement(_.merge(args, { shippingCategoryOptions: this.shippingCategoryOptions }));
        case 'wifi':
          return new WifiElement(_.merge(args, { wifiProviderOptions: this.wifiProviderOptions }));
        case 'room':
          return new RoomElement(args);
        case 'kit':
          return new KitElement(args);
        case 'travel_authorization':
          return new TravelAuthorizationElement(args);
        case 'insurance':
          return new InsuranceElement(args);
      }
    })();
    this.elements.push(element);
    this.updatePriceShowFee();
    this.updatePriceMarginType();
    this.updateTravelerInformationShinkansenTypes('add');
    this.fetchCategory();
    return app.render();
  }

  fetchCategory() {
    return Fetcher.get('/arrangement/order_item_categories', this.updateParams(), { parser: 'jquery' }).then(
      result => {
        this.orderItemCategory = result.order_item_category;
        return app.render();
      }
    );
  }

  updatePriceShowFee() {
    if (this.showFee) {
      return;
    }
    this.price.showFee = false;
    return app.render();
  }

  updatePriceMarginType() {
    this.price.marginType = this.currentMarginType();
    return app.render();
  }

  updateTravelerInformationShinkansenTypes(addOrRemove, index) {
    if (index == null) {
      index = 0;
    }
    for (var traveler of Array.from(this.travelerInformations)) {
      // 未設定の場合は何もしない
      if (_.isEmpty(traveler.travelerInformationShinkansenTypes)) {
        continue;
      }

      if (addOrRemove === 'add') {
        // 最後のelementの情報を利用
        var element = _.last(this.elements);
        var shinkansenType = new TravelerShinkansenType({
          travelerInformationId: traveler.id,
          shinkansenTicketType:
            traveler.shinkansenTicketType || (element != null ? element.railwayTicketType : undefined) || 'normal',
          shinkansenSeatType:
            traveler.shinkansenSeatType || (element != null ? element.railwaySeatType : undefined) || 'normal'
        });
        traveler.travelerInformationShinkansenTypes.push(shinkansenType);
      } else if (addOrRemove === 'remove') {
        // indexはTravelerShinkansenTypeの配列のindex
        traveler.travelerInformationShinkansenTypes.splice(index, 1);
      }
    }

    return app.render();
  }

  handleTransportTypeChange(transportElement, value) {
    transportElement.handleTransportTypeChange(value);
    this.updatePriceMarginType();
    this.fetchCategory();
    return app.render();
  }

  handleRemoveElement(index) {
    this.elements.splice(index, 1);
    this.updatePriceMarginType();
    this.updateTravelerInformationShinkansenTypes('remove', index);
    this.fetchCategory();
    return app.render();
  }

  description() {
    return `\
${
  this.orderItemCategory === 'arrangement_request'
    ? 'リクエストフォーム利用料'
    : _.map(this.elements, el => el.description()).join('\n\n')
}

${this.price.description()}\
`;
  }

  validationErrors() {
    const { status } = this;
    const errors = _.map(this.elements, element => element.validationErrors(status));
    errors.push(this.price.validationErrors());
    if (this.travelerInformations.length === 0) {
      errors.push(['出張者が誰もいません']);
    }
    if (!this.isPaymentPossible()) {
      errors.push(['海外航空券はカード払いでは購入できません']);
    }
    return errors;
  }

  currentMarginType() {
    if (this.marginType) {
      return this.marginType;
    } else if (this.marginTypes) {
      // 旧ソース(@marginTypeがセットされない場合用)
      if (this.isForeignAirOnly()) {
        return this.marginTypes.foreignMarginType();
      } else {
        // 海外/国内が存在した場合、国内航空券の手数料を利用
        // 通常のユースケースでは発生しない
        return this.marginTypes.domesticMarginType();
      }
    }
  }

  isPaymentPossible() {
    // 海外航空券のelements
    const foreign_flights = _.filter(this.elements, e => e.type === 'transport' && e.isForeignAir());
    if (this.payment.paymentType === 0 && foreign_flights.length > 0) {
      // クレカ払いかつ海外航空券が1件以上 -> 支払い不可
      return false;
    } else {
      return true;
    }
  }

  isNeedReCalcMarginAmount() {
    return this.price.isNeedReCalcMarginAmount();
  }

  updateParams() {
    if (_.isEmpty(this.elements) && this.orderItemCategory !== 'arrangement_request') {
      return null;
    } else {
      return {
        price: this.price.updateParams(),
        payment: this.payment.updateParams(),
        elements: _.map(this.elements, e => e.updateParams()),
        people_num: this.peopleNum,
        trace_id: this.traceId,
        modified: this.isEditing,
        job_type: this.jobType,
        status: this.status,
        billed_at: this.billedAt != null ? this.billedAt.format() : undefined,
        order_item_category: this.orderItemCategory,
        pnr_id: this.pnrId,
        foreign_flight_ticket_issuer: this.foreignFlightTicketIssuer,
        tsd_invoice_number: this.tsdInvoiceNumber,
        ticketed_at: this.ticketedAt,
        delivered_at: this.deliveredAt,
        approved_at: this.approvedAt,
        jr_auth_code: this.jrAuthCode,
        jr_pickup_code: this.jrPickupCode,
        is_working: this.isWorking,
        working_arranger_id: this.workingArrangerId,
        work_started_at: this.workStartedAt,
        work_ended_at: this.workEndedAt,
        purchase_deadline: this.purchaseDeadline != null ? this.purchaseDeadline.format() : undefined,
        traveler_informations: this.travelerInformations.map(t => ({
          air_seat: t.airSeat,
          birthday: t.birthday,
          first_name_kana: t.firstNameKana,
          last_name_kana: t.lastNameKana,
          first_name_roman: t.firstNameRoman,
          last_name_roman: t.lastNameRoman,
          flight_first_name: t.flightFirstName,
          flight_last_name: t.flightLastName,
          flight_middle_name: t.flightMiddleName,
          flight_first_name_kana: t.flightFirstNameKana,
          flight_last_name_kana: t.flightLastNameKana,
          flight_first_name_roman: t.flightFirstNameRoman,
          flight_last_name_roman: t.flightLastNameRoman,
          flight_middle_name_roman: t.flightMiddleNameRoman,
          flight_birthday: t.flightBirthday,
          flight_gender: t.flightGender,
          flight_tel: t.flightTel ? t.flightTel.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '') : '',

          // 手配画面の出張者編集で仮IDを付与しているため
          id: (t.id != null ? t.id.toString().match(/^temp-.*/) : undefined) ? null : t.id,

          // transport_element_attach_filesのtraveler_information_idとの紐付けに使用
          id_original: t.id,

          middle_name_roman: t.middleNameRoman,
          mileage_number: t.mileageNumber,
          passport_expire: t.passportExpire,
          passport_issued_country: t.passportIssuedCountry,
          passport_number: t.passportNumber,
          shinkansen_seat: t.shinkansenSeat,
          shinkansen_seat_type: t.shinkansenSeatType,
          shinkansen_ticket_type: t.shinkansenTicketType,
          exic_number: t.exicNumber,
          exic_password: t.exicPassword,
          exic_card_id: t.exicCardId,
          user_id: t.userId,
          traveler_information_shinkansen_types:
            t.travelerInformationShinkansenTypes != null
              ? t.travelerInformationShinkansenTypes.map(s => new TravelerShinkansenType(s).updateParams())
              : undefined
        }))
      };
    }
  }

  handlePeopleNumChange(value) {
    this.peopleNum = value;
    for (var el of Array.from(this.elements)) {
      el.peopleNum = value;
    }

    this.price.setPeopleNum(this.peopleNum);
    return app.render();
  }

  handleJobTypeChange(value) {
    this.jobType = value;
    return app.render();
  }

  handleStatusChange(value) {
    this.status = value;
    this.statusStr = this.status ? OrderItemStatus[this.status] : '';
    return app.render();
  }

  handleWaitingChange(value) {
    this.waiting = value;
    return app.render();
  }

  handleBilledAtChange(value) {
    if (value) {
      this.billedAt = moment(value);
    }
    return app.render();
  }

  handlePnrIdChange(value) {
    this.pnrId = value.replace(/[ 　]/g, '');
    return app.render();
  }

  handleForeignFlightTicketIssuerChange(value) {
    this.foreignFlightTicketIssuer = value;
    return app.render();
  }

  handleTsdInvoiceNumber(value) {
    this.tsdInvoiceNumber = value;
    return app.render();
  }

  handleJrAuthCode(value) {
    this.jrAuthCode = value;
    return app.render();
  }

  handleJrPickupCode(value) {
    this.jrPickupCode = value;
    return app.render();
  }

  handlePurchaseDeadline(value) {
    if (value) {
      this.purchaseDeadline = moment(value);
    }
    return app.render();
  }

  elementChanged(elementId) {
    let changed = false;
    const element = this.elements.find(e => e.id === elementId);
    const initElement = this.initialData.elements.find(e => e.id === elementId);
    for (var k in element) {
      var v = element[k];
      if (`${v}` !== `${initElement[k]}`) {
        changed = true;
        break;
      }
    }

    return changed;
  }

  addTraveler(traveler) {
    this.travelerInformations.push(traveler);
    return this.updatePeopleNum();
  }

  updateTraveler(traveler) {
    const index = this.travelerInformations.findIndex(t => t.id === traveler.id);
    this.travelerInformations.splice(index, 1, traveler);
    return this.updatePeopleNum();
  }

  removeTraveler(travelerId) {
    const index = this.travelerInformations.findIndex(t => t.id === travelerId);
    this.travelerInformations.splice(index, 1);
    return this.updatePeopleNum();
  }

  updatePeopleNum() {
    this.elements.forEach(e => {
      return (e.peopleNum = this.travelerInformations.length);
    });
    return this.price.setPeopleNum(this.travelerInformations.length);
  }

  diffWith(orderItem) {
    if (orderItem) {
      const thisItem = _.cloneDeep(this);
      const originalItem = _.cloneDeep(orderItem);
      delete thisItem.initialData;
      delete originalItem.initialData;
      delete thisItem.order;
      delete originalItem.order;
      return diff(originalItem, thisItem);
    } else {
      return null;
    }
  }

  _restore() {
    return _.assign(this, _.cloneDeep(this.initialData));
  }
}

module.exports = OrderItem;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
